









// @ is an alias to /src
import TitleBar from '@/modules/core/components/TitleBar.vue';
import UserEdit from '../components/UserEdit.vue';
import { Component, Vue } from 'vue-property-decorator';
import { userApi } from '../user.api';
import { roles, RoleType } from '@shared/common/types';
import { User } from '../user';

// return this.$router.currentRoute.params.id;

// subscriber: {
//   role: RoleType.SUBSCRIBER,
// },

@Component({
  components: {
    UserEdit,
    TitleBar,
  },
})
export default class UserEditView extends Vue {
  public user: User | null = null;

  public get titleStack(): string[] {
    return ['Admin', this.title];
  }

  public get forceRole(): boolean {
    return !!this.role;
  }

  public get title(): string {
    let role;

    if (this.userId && this.user) {
      role = this.user.role;
    } else if (this.role) {
      role = this.role;
    }

    if (role) {
      return roles[role as RoleType][(this.userId ? 'updateLabel' : 'creationLabel')] as string;
    } else {
      return (this.userId ? 'Mise à jour' : 'Création') + ' utilisateur';
    }
  }

  public get userId(): string {
    return this.$router.currentRoute.params.id;
  }

  public get role(): string {
    return this.$route.query.role as string;
  }

  public goBack(): void {
    this.$router.go(-1);
  }

  public async mounted(): Promise<void> {
    if (this.userId) {
      this.user = await userApi.get(this.userId);
    } else {
      this.user = new User({ role: this.$route.query.role });
    }
  }
}
